import { Event } from 'main.core';


// TODO: throw an error if the state is not changing in action
class Store extends Event.EventEmitter
{
	state = {};
	#actions = {};
	
	constructor(params)
	{
		super();

		const { initialState, actions } = params;

		if (typeof initialState !== 'object') 
			throw new Error(`State must be an object`);

		this.state = { ...initialState };

		if (actions)
			this.#actions = { ...actions };

		this.setEventNamespace('EShop24.Store');
		this.setMaxListeners(9999);
	}

	dispatch(payload = {})
	{
		const { type } = payload;
		const entry = this.#actions[type];

		if (typeof entry !== 'function')
		{
			console.error(`Unknown action type: ${type}`);
			return false;
		}

		try
		{
			const { state } = this;
			const emit = (eventName, event) => this.emit(eventName, event);
			const dispatch = (payload = {}) => this.dispatch(payload);
			
			return entry({ state, emit, dispatch }, payload);
		}
		catch (e)
		{
			console.error(e);
			return false;
		}
	}
}

export default Store;